export class Loans {
    ID:number;
CLIENT_ID:number;
YEAR_NAME:string;
AMOUNT:number;
PERCENTAGE:number;
PERCENTAGE_TOTAL:number;
SEQUENCE_NO:number;
STATUS:boolean=true;

}